import { useUserStore } from "@/store/user";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";
import { usePopupStore } from "@/store/popup.ts";
import { POPUP_LAW_LIMITATION } from "@/utils/variables.ts";

export default async ({ from, to, redirect, pinia }: MiddlewareInterface) => {
  if (to.meta.lawLimited && useUserStore().hasLawLimitations) {
    if (from.path === "/") {
      usePopupStore(pinia).show(POPUP_LAW_LIMITATION);

      redirect("/");
      return;
    }

    usePopupStore(pinia).show(POPUP_LAW_LIMITATION);
    redirect(false);
  }
};
